import React from 'react'
import PropTypes from 'prop-types'
import './FilterListItem.scss'

const FilterListItem = ({
  onSelect,
  filteredLabels,
  label,
  content,
  isExpanded,
  isFullscreen,
  onFilterSelected
}) => {
  let itemContent
  if (isExpanded && content) {
    itemContent = (
      <div className='FilterListItem__content'>{content(onFilterSelected)}</div>
    )
  }

  let labels = ''
  if (filteredLabels.length > 0) {
    filteredLabels.forEach((item, idx) => {
      labels += item
      if (idx !== filteredLabels.length - 1) {
        labels += ', '
      }
    })
  } else if (isFullscreen) {
    labels = 'All'
  }

  return (
    <div className='FilterListItem' onClick={onSelect}>
      <div className='FilterListItem__header'>
        <div className='FilterListItem__label'>{label}</div>
        <div className='FilterListItem__filtered'>{labels}</div>
      </div>
      {itemContent}
    </div>
  )
}

FilterListItem.defaultProps = {
  filteredLabels: [],
  onFilterSelected: () => {}
}

FilterListItem.propTypes = {
  onSelect: PropTypes.func.isRequired,
  content: PropTypes.func,
  label: PropTypes.string,
  isExpanded: PropTypes.bool,
  onFilterSelected: PropTypes.func,
  filteredLabels: PropTypes.array
}

export default FilterListItem
